export const manifest = {
  screens: {
    scr_c4hvaq: { name: "Home", route: "/" },
  },
}
